function Right({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2 0L0.589996 1.41L5.17 6L0.589996 10.59L2 12L8 6L2 0Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Right;
